module.exports = __webpack_public_path__ + "img/Bitcoin Icon - charcoal.811b9008.svg";